// src/helpers/landing.js
export function initLandingPlugins() {
    if (window.$ && window.$.fn.counterUp) {
        window.$('.counter').counterUp()
    }
}
